




































































import {Component, Vue} from "vue-property-decorator";
import PagedTableView from "@/components/PagedTableView/index.vue";
import api from '@/api'
import {ExpenditureDetailDto} from "@/api/appService";
import ImportExcel from "@/components/ImportExcel/index.vue";


@Component({
  name: 'ExpenditureDetail',
  components: {
    PagedTableView,
    ImportExcel
  }
})
export default class ExpenditureDetailManagement extends Vue {


  queryForm = {
    startDate: '',
    endDate: '',
    keywords: ''
  }

  fetchData(params: any) {
    return api.expenditureDetail.getAll(params)
  }

  async handleDelete(index: number, row: ExpenditureDetailDto) {
    this.$confirm("你确定删除吗?", "提示").then(async () => {
      await api.expenditureDetail
        .delete({
          id: row.id,
        })
        .then((res) => {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        });
    });
  }

}

